<!-- Componente para hacer calculos  -->
<script>
  import { tick } from "svelte";
  import { ButtonV2, CardV2, TextField, Snackbar } from "$lib";
  import { _ } from "$helpers/i18n.js";
  import { calculateCashflowDaily, FormatNumber } from "../../../helpers/calculator";
  import { globalStore } from "../../store/globalStore";

  const { country } = globalStore;

  let initialBalance = null;
  let totalSales = null;
  let dailyIncome = null;
  let dailyExpenses = null;

  let result = null;

  $: initialBalance, totalSales, dailyIncome, dailyExpenses, (result = null);

  let resultEl;

  // Variables para el Snackbar
  let showSnackbar = false;
  let snackbarMessage = "";

  async function calculate() {
    // Resetear snackbar
    showSnackbar = false;

    if (initialBalance < 0 || totalSales < 0 || dailyIncome < 0 || dailyExpenses < 0) {
      snackbarMessage = $_("snackbar.commons.positive_values");
      showSnackbar = true;
      return;
    }
    
    result = calculateCashflowDaily(initialBalance, totalSales, dailyIncome, dailyExpenses, $country).result;

    await tick();
    resultEl?.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

</script>

<CardV2 variant="outlined">
  <div on:keydown={(event) => event.key == '-' && event.preventDefault()}>
    <p>{$_("cashflowDaily.calculation.first_input")}</p>
    <TextField
      placeholder="0"
      leadingText={$_("common.currency_symbol")}
      bind:value={initialBalance}
      type="number"
      step="0.01"
      min={0}
      testId="cashflowDInitialBalanceInput" 
      />
  </div>
  <div on:keydown={(event) => event.key == '-' && event.preventDefault()}>
    <p>{$_("cashflowDaily.calculation.second_input")}</p>
    <TextField
      placeholder="0"
      leadingText={$_("common.currency_symbol")}
      bind:value={totalSales}
      type="number"
      step="0.01"
      min={0} 
      testId="cashflowDTotalSalesInput"
      />
  </div>
  <div on:keydown={(event) => event.key == '-' && event.preventDefault()}>
    <p>{$_("cashflowDaily.calculation.third_input")}</p>
    <TextField
      placeholder="0"
      leadingText={$_("common.currency_symbol")}
      bind:value={dailyIncome}
      type="number"
      step="0.01"
      min={0}
      testId="cashflowDDailyIncomeInput"
    />
  </div>
  <div on:keydown={(event) => event.key == '-' && event.preventDefault()}>
    <p>{$_("cashflowDaily.calculation.fourth_input")}</p>
    <TextField
      placeholder="0"
      leadingText={$_("common.currency_symbol")}
      bind:value={dailyExpenses}
      type="number"
      step="0.01"
      min={0}
      testId="cashflowDDailyExpensesInput"
    />
  </div>
  <ButtonV2 variant="primary" class="btn-principal" on:click={calculate} dataTrack="calculate_cashflow_daily">
    {$_("common.calculate_button")}
  </ButtonV2>

  {#if result != null}
    <div class="result-static" class:negative={result < 0} data-testid="cashflowDCalculationResult" bind:this={resultEl}>
      <p>{$_("cashflowDaily.calculation.result")}</p>
      {FormatNumber($country, result)}
    </div>
  {/if}
  <Snackbar 
    variant="warning" 
    visible={showSnackbar} 
    message={snackbarMessage} 
    on:close={() => (showSnackbar = false)}
  />
</CardV2>

